export const FILTERED_MINE_COLOR = "#F75151";
export const DEFAULT_MINE_COLOR = "#043D5D";
export const FILTERED_VIEWED_MINE_COLOR = "#f77d51";
export const VIEWED_MINE_COLOR = "#4c355b";
